const alarmSrc = {
  all: "Todos",
  cortex: "Córtex",
  sentry: "Sentry",
  outros: "Outros"
}

export const alarmSrcArr = Object.entries(alarmSrc).map(([key, value]) => ({value: key, label: value}));

const alarms = {
  all: "Todos",
  with: "Sem assinatura", // Parece que confundiram with com without, como no backend estava assim também,
  without: "Assinatura automática", // eu mantive conforme estava o blade.
  sign1: "1ª fase",
  sign2: "2ª fase"
}

export const alarmArr = Object.entries(alarms).map(([key, value]) => ({value: key, label: value}));

export function deconstructObjAsArr(data = {}, keys = []){
  return keys.map(key => ({label: key.label ?? "", value: data[key.value]}));
}
export const alarmDataKey = [
  {label: "PLACA:", value: "plate"},
  {label: "PONTO DE COLETA:", value: "description"},
  {label: "SENTIDO:", value: "region_type"},
  {label: "DATA/HORA", value: "capture_time"}
];

export const vehicleDataKey = [
  {label: "PLACA:", value: "plate"},
  {label: "MARCA/MODELO:", value: "brandmodel"},
  {label: "TIPO:", value: "type"},
  {label: "COR:", value: "color"},
  {label: "MUNICÍPIO PLACA:", value: "city"}
]

export const cortexDataKey = [
  {label: "BO:", value: "bo"},
  {label: "DECLARANTE:" , value: "declarant"},
  {label: "VEÍCULO:", value: "vehicle"},
  {label: "CHASSI:", value: "chassi"},
  {label: "ORIGEM:", value: "origin"},
  {label: "HISTÓRICO:", value: "history"}
]

export const eventsTimesKey = [
  {label: "CAPTURA", value: "capture_time"},
  {label: "INSERÇÃO", value: "insertiontime"},
  {label: "PROCESSAMENTO NA CENTRAL", value: "ocrtime"},
  {label: "ASSUMIU O ALARME", value: "datetimeassume"},
  {label: "ASS. 1ª FASE", value: "datetimesign1"},
  {label: "ASS. 2ª FASE", value: "datetimesign2"},
]

export function translateCortexObj(obj){
  if(!obj) return {
    bo: "",
    declarant: "",
    vehicle: "",
    chassi: "",
    origin: "",
    history: ""
  }

  return JSON.parse(obj);
}